'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../sections/product');

(0, _themeSections.load)('*');